import { render, staticRenderFns } from "./MyRankingCard.vue?vue&type=template&id=6c941790&"
import script from "./MyRankingCard.vue?vue&type=script&lang=js&"
export * from "./MyRankingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports